import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import { BackgroundInfoForm } from "./BackgroundInfoForm";
import { CustomSelect, GraduationTypeOptions } from "../../../../../../_helpers/Helpers";

export function PersonnelEducationalBackgroundInfoForm({
  handleChange,
  setFieldValue,
  values
 }) {
  return (
    <>
      <Form.Group as={Row} controlId="graduationType">
        <Form.Label column sm={3}>
          Eğitim Durumu
        </Form.Label>
        <Col sm={6}>
          <CustomSelect 
            options={GraduationTypeOptions}
            value={values.graduationType}
            onChange={option => setFieldValue("graduationType", option.value)}
          />
        </Col>
      </Form.Group>
      <BackgroundInfoForm
        graduationTypeName={"Lisans"}
        graduationType={"graduate"}
        handleChange={handleChange}
        values={values.graduate}
      />      
      <BackgroundInfoForm
        graduationTypeName={"Yüksek Lisans"}
        graduationType={"postGraduate"}
        handleChange={handleChange}
        values={values.postGraduate}
      />
      <BackgroundInfoForm
        graduationTypeName={"Doktora"}
        graduationType={"doctorate"}
        handleChange={handleChange}
        values={values.doctorate}
      />
    </>
  );
}